import "../scss/main.scss";

import "./elements/header";
import "./elements/banner";

import "./pages/creators";
import "./pages/partners";
import "./pages/quotes";
import "./pages/single-posts";


document.addEventListener("DOMContentLoaded", () => {

});



// WEBPACK FOOTER //
// ./src/js/main.js